export const isIOGTransactionType = (transactionType) =>
  typeof transactionType === "string" &&
  transactionType.length === 20 &&
  transactionType.charAt(12) === "1";
